'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = require('../FormField');

var _FormField2 = _interopRequireDefault(_FormField);

var _primitives = require('../primitives');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DefaultFormLayout = function DefaultFormLayout(_ref, _ref2) {
  var _ref$hasEdit = _ref.hasEdit,
      hasEdit = _ref$hasEdit === undefined ? true : _ref$hasEdit;
  var fields = _ref2.fields,
      setMode = _ref2.setMode,
      mode = _ref2.mode,
      submit = _ref2.submit;
  return _react2["default"].createElement(_primitives.View, {
    style: {
      padding: 7
    }
  }, mode !== 'add' && mode !== 'edit' && hasEdit && _react2["default"].createElement(_primitives.Button, {
    onPress: function onPress() {
      setMode('edit');
    },
    title: "Edit"
  }), Object.keys(fields).map(function (fieldName, index) {
    return _react2["default"].createElement(_FormField2["default"], {
      key: index,
      name: fieldName
    });
  }), (mode === 'edit' || mode === 'add') && _react2["default"].createElement(_primitives.Button, {
    onPress: function onPress() {
      submit();
    },
    title: "Done"
  }));
};

DefaultFormLayout.contextTypes = {
  fields: _propTypes2["default"].object,
  setMode: _propTypes2["default"].func,
  mode: _propTypes2["default"].string,
  submit: _propTypes2["default"].func
};
exports["default"] = DefaultFormLayout;